import React, { useEffect, useRef, useState } from 'react';
import Modal from './Modal';

const emptyForm = {
  account: '',
  username: '',
  password: '',
  url: '',
  note: '',
};

const AccountFormModal = ({
  isOpen,
  mode,
  initialValues,
  onClose,
  onSave,
  saving,
  error,
}) => {
  const [form, setForm] = useState(emptyForm);
  const noteRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setForm({
        account: initialValues?.account || '',
        username: initialValues?.username || '',
        password: initialValues?.password || '',
        url: initialValues?.url || '',
        note: initialValues?.note || '',
      });
    }
  }, [isOpen, initialValues]);

  useEffect(() => {
    const textarea = noteRef.current;
    if (!textarea) return;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }, [form.note, isOpen]);

  const handleChange = (field) => (event) => {
    setForm((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSave(form);
  };

  const title = mode === 'edit' ? 'Edit account' : 'Add account';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      footer={
        <>
          <button
            type="button"
            onClick={onClose}
            disabled={saving}
            className="border border-gray-300 bg-white rounded-lg px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="submit"
            form="account-form"
            disabled={saving}
            className="bg-orange-500 hover:bg-orange-600 text-white rounded-lg px-4 py-2 text-sm disabled:opacity-50"
          >
            {saving ? 'Saving...' : 'Save'}
          </button>
        </>
      }
    >
      <form id="account-form" onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="account" className="block text-sm text-gray-700 mb-1">
            Account name
          </label>
          <input
            id="account"
            type="text"
            value={form.account}
            onChange={handleChange('account')}
            required
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm outline-none focus:border-gray-400"
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label htmlFor="username" className="block text-sm text-gray-700 mb-1">
              Username
            </label>
            <input
              id="username"
              type="text"
              value={form.username}
              onChange={handleChange('username')}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm outline-none focus:border-gray-400"
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm text-gray-700 mb-1">
              Password
            </label>
            <input
              id="password"
              type="text"
              value={form.password}
              onChange={handleChange('password')}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm outline-none focus:border-gray-400"
            />
          </div>
        </div>

        <div>
          <label htmlFor="url" className="block text-sm text-gray-700 mb-1">
            Link
          </label>
          <input
            id="url"
            type="url"
            value={form.url}
            onChange={handleChange('url')}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm outline-none focus:border-gray-400"
          />
        </div>

        <div>
          <label htmlFor="note" className="block text-sm text-gray-700 mb-1">
            Note
          </label>
          <textarea
            id="note"
            ref={noteRef}
            value={form.note}
            onChange={handleChange('note')}
            rows={1}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm resize-none overflow-hidden outline-none focus:border-gray-400"
          />
        </div>

        {error && (
          <p className="text-sm text-red-600">{error}</p>
        )}
      </form>
    </Modal>
  );
};

export default AccountFormModal;
